import { Button, Checkbox, Spinner, Text, VerticalStack, Divider, HorizontalStack, AlphaCard, Avatar, HorizontalGrid, Select, RadioButton, TextField, Icon, Box, Image, Modal, Badge, Link, ButtonGroup } from "@shopify/polaris";
import { BehaviorMajor, TickMinor, ClockMinor, CustomersMajor, ImagesMajor, AddProductMajor, PagePlusMajor, LocationMajor, ProductsMajor, CashDollarMajor, ChecklistMajor, DuplicateMinor, LinkMinor } from "@shopify/polaris-icons";

import { Instagram, Tiktok, Youtube, copyToClipboard, numberToUSD } from "../utils";
import { usePartnerUp } from "../providers/PartnerUpProvider";
import ContentUploadPanel from "./content-upload-panel";
import { getContent } from "../firebase";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

function getDealBadges(deal, payments) {
  const badges = []
  if (deal?.payments?.whenPayment === 'Up Front' && !payments?.length) {
    badges.push(<Badge status="warning">Awaiting Up-Front Payment</Badge>)
  }
  if (deal?.period?.end) {
    if (deal?.contentStatus === 'allApproved' || deal?.contentStatus === 'allDeployed') {
      badges.push(<Badge status="success">All Approved</Badge>)
    } else {
      const periodEndDate = new Date(deal?.period?.end)
      badges.push(<Badge status={periodEndDate > new Date() ? 'info' : 'critical'}>Due {new Date(deal?.period?.end)?.toLocaleDateString()}</Badge>)
    }
  }
  return (
    <VerticalStack inlineAlign="center" gap="1">
      {badges}
    </VerticalStack>
  )
}

function ContentItem({ format, quantity, showQuantity }) {
  const icon = (
    <HorizontalStack>
      <Icon source={format.includes('tiktok') ? Tiktok : format.includes('youtube') ? Youtube : format.includes('instagram') ? Instagram : format === 'bundle' ? 'bundle' : 'bundle'} />
    </HorizontalStack>
  )
  let contentString = format;
  if (format === 'tiktokShort') {
    contentString = 'TikTok Short'
  } else if (format === 'instagramPost') {
    contentString = 'Instagram Post'
  } else if (format === 'instagramStory') {
    contentString = 'Instagram Story'
  } else if (format === 'youtubeVideo') {
    contentString = 'YouTube Video'
  } else if (format === 'instagramReel') {
    contentString = 'Instagram Reel'
  }
  if (format === 'instagramStory') {
    contentString = `${showQuantity ? quantity : ''} ${showQuantity && quantity === 1 ? 'Instagram Story' : 'Instagram Stories'}`
  } else {
    contentString = `${showQuantity ? quantity : ''} ${contentString}${showQuantity && quantity === 1 ? '' : 's'}`
  }
  return (
    <AlphaCard>
      <HorizontalStack gap="1" align="start">
        {icon}
        <Text variant="headingMd">{contentString}</Text>
      </HorizontalStack>
    </AlphaCard>
  )
}
export default function DealModal({ profile, deal, content, refetchContent, onClose, storeCustomDomain, payments, refetchDeal }) {

  console.log('deal is', deal)

  const { setToasts } = usePartnerUp();

  const reviewOrChangesContent = content?.filter(c => c.status === 'approved' || c.status === 'needsReview' || c.status === 'changesRequested') || []

  console.log('ccc', content)

  const [localNewContent, setLocalNewContent] = useState([])

  if (!deal) {
    return <Modal open={false} onClose={onClose} />
  }

  const hasFullLogo = Boolean(profile?.storeData?.logo)

  console.log('profile is', profile)

  console.log('deal is', deal)

  return (
    <VerticalStack gap="3">
      <AlphaCard>
        <VerticalStack gap="5">
          <HorizontalStack gap="3" align="start">
            <HorizontalStack>
              <Icon source={CustomersMajor} />
            </HorizontalStack>
            <VerticalStack gap="1">
              <Text variant="headingMd">Campaign Overview</Text>
            </VerticalStack>
          </HorizontalStack>
          <Divider />
          <VerticalStack gap="3">
            <div dangerouslySetInnerHTML={{ __html: deal?.specs?.overview }} />
          </VerticalStack>
        </VerticalStack>

      </AlphaCard>
      {
        (deal?.payments?.includeAffiliate) && (
          <AlphaCard>
            <VerticalStack gap="5">
              <HorizontalStack align="space-between">
                <HorizontalStack gap="3" align="start" blockAlign="center">
                  <HorizontalStack>
                    <Icon source={BehaviorMajor} />
                  </HorizontalStack>
                  <VerticalStack gap="1">
                    <Text variant="headingMd">Affiliate</Text>
                  </VerticalStack>
                </HorizontalStack>
              </HorizontalStack>
              <Divider />
              {
                /*
                    deal?.affiliateFields?.code ? (
                      <>
                        <HorizontalStack align="start" gap="1">
                          <VerticalStack gap="1">
                            <Text variant="bodyLg">Share this URL</Text>
                            <Box onClick={() => copyToClipboard('https://' + storeCustomDomain + '.prup.io/' + deal?.affiliateFields?.code, setToasts)} >
                              <HorizontalStack>
                                <Link removeUnderline>{'https://' + storeCustomDomain + '.prup.io/' + deal?.affiliateFields?.code}</Link>
                                <Icon color="interactive" source={DuplicateMinor} />
                              </HorizontalStack>
                            </Box>
                          </VerticalStack>
                        </HorizontalStack>
                        <Divider />
                      </>
                    ) : null
    */
              }
              <HorizontalGrid gap="5" columns="2">
                <VerticalStack>
                  {
                    deal?.affiliateFields?.discountType === 'freeShipping' ? (
                      <Text variant="headingLg">Free Shipping{deal?.affiliateFields?.usOnly ? ', US Only' : ''}</Text>
                    ) : deal?.affiliateFields?.discountType === 'fixed' ? (
                      <Text variant="headingLg">${deal.affiliateFields?.discountFixedValue} Off Per Order</Text>
                    ) : (
                      <Text variant="headingLg">{deal.affiliateFields?.discountPercentage}% Discount</Text>
                    )
                  }
                  <Text>For Customers</Text>
                </VerticalStack>
                <VerticalStack>
                  <Text variant="headingLg">{deal.affiliateFields?.commission}% Commission</Text>
                  <Text>On Revenue You Generate</Text>
                </VerticalStack>
              </HorizontalGrid>
            </VerticalStack>
          </AlphaCard>
        )
      }
      <AlphaCard>
        <VerticalStack gap="5">
          <HorizontalStack align="space-between">
            <HorizontalStack gap="3" align="start" blockAlign="center">
              <HorizontalStack>
                <Icon source={ImagesMajor} />
              </HorizontalStack>
              <VerticalStack>
                <Text variant="headingMd">Content</Text>
              </VerticalStack>
            </HorizontalStack>
            <HorizontalStack gap="1">
              <Badge>{deal?.content?.baseType}</Badge>
              {
                deal?.period && (
                  (!deal?.periodPaid && new Date(deal?.period.end) < new Date()) ? (
                    <Badge status="critical">Due {new Date(deal?.period?.end).toLocaleDateString()}</Badge>
                  ) : (
                    <Badge>Due {new Date(deal?.period?.end)?.toLocaleDateString()}</Badge>
                  )
                )
              }
            </HorizontalStack>
          </HorizontalStack>
          <Divider />
          <HorizontalStack align="center" blockAlign="end" gap="5" columns={deal?.content?.baseType === 'evergreen' ? "2" : "4"}>
            {
              deal?.content?.formats?.map((format, index) => {
                const key = Object.keys(format)[0]
                const quantity = format[key]
                console.log('format is', format)
                return (
                  <ContentItem key={index} format={key} quantity={quantity} showQuantity={deal?.content?.baseType !== 'evergreen'} />
                )
              })
            }
            {
              (deal?.content?.baseType !== 'evergreen') ? (
                <VerticalStack inlineAlign="center">
                  <Text variant="headingLg">{deal.content?.dueInDays} Day</Text>
                  <Text variant="bodyMd">{deal?.content?.baseType === 'fixed' ? "Deadline" : "Recurring"} </Text>
                </VerticalStack>
              ) : (
                null
              )
            }
          </HorizontalStack>
          <HorizontalStack align="space-between">
            <HorizontalStack gap="2">
              {
                deal?.content?.delayOnAccept && deal?.content?.delayStartDays && deal?.content?.delayStartDays !== 0 ? (
                  <HorizontalStack blockAlign="center">
                    <Icon source={ClockMinor} color="base" />
                    <Text variant="bodySm">Starts {deal?.content?.delayStartDays} Days After Accepted</Text>
                  </HorizontalStack>
                ) : null
              }
            </HorizontalStack>
          </HorizontalStack>
          <Divider />
          {
            deal?.content?.reviewContent && deal?.status === 'active' ? (
              <VerticalStack gap="5">
                <ContentUploadPanel
                  startingIndex={content?.length}
                  content={reviewOrChangesContent.concat([{ status: 'new' }])}
                  newContent={localNewContent}
                  profile={profile}
                  clickedDeal={deal} refetchDeal={refetchDeal} refetchContent={refetchContent} />
              </VerticalStack>
            ) : null
          }
        </VerticalStack>
      </AlphaCard>
      {
        (deal?.payments?.price) ? (
          <AlphaCard>
            <VerticalStack gap="5">
              <HorizontalStack align="space-between">
                <HorizontalStack gap="3" align="start" blockAlign="center">
                  <HorizontalStack>
                    <Icon source={BehaviorMajor} />
                  </HorizontalStack>
                  <VerticalStack gap="1">
                    <Text variant="headingMd">Fixed Payment</Text>
                  </VerticalStack>
                </HorizontalStack>
                <VerticalStack inlineAlign="end">
                  {
                    deal?.payments?.whenPayment === 'Up Front' ? (
                      !payments?.length ? <Badge status="warning">Pending</Badge> : <Badge status="success">Paid</Badge>
                    ) : content?.length && content?.every(c => c.paid) ? <Badge status="success">Paid</Badge> : <Badge status="warning">Pending</Badge>
                  }
                </VerticalStack>
              </HorizontalStack>
              <Divider />
              <HorizontalGrid gap="5" columns="2">
                <VerticalStack>
                  <Text variant="headingLg">{numberToUSD(deal.payments?.price)}</Text>
                  <Text>{deal?.payments?.whenPayment}</Text>
                </VerticalStack>
              </HorizontalGrid>
            </VerticalStack>
          </AlphaCard>
        ) : null
      }
      {
        deal?.specs?.script || deal?.specs?.creativeDirection || deal?.specs?.inspiration || deal?.assets?.length ? (
          <AlphaCard>
            <VerticalStack gap="5">
              <HorizontalStack gap="3" align="start">
                <HorizontalStack>
                  <Icon source={ChecklistMajor} />
                </HorizontalStack>
                <VerticalStack>
                  <Text variant="headingMd">Requirements</Text>
                </VerticalStack>
              </HorizontalStack>
              <Divider />
              <VerticalStack gap="5">
                {
                  deal?.specs?.script ? (
                    <>
                      <VerticalStack gap="2">
                        <Text variant="headingSm">Guidelines</Text>
                        <VerticalStack gap="1">
                          <div dangerouslySetInnerHTML={{ __html: deal?.specs?.script }} />
                        </VerticalStack>
                      </VerticalStack>
                      <Divider />
                    </>
                  ) : null
                }
                {
                  deal?.specs?.creativeDirection ? (
                    <>
                      <VerticalStack gap="2">
                        <Text variant="headingSm">Creative Direction</Text>
                        <VerticalStack gap="1">
                          <div dangerouslySetInnerHTML={{ __html: deal?.specs?.creativeDirection }} />
                        </VerticalStack>
                      </VerticalStack>
                      <Divider />
                    </>
                  ) : null
                }
                {
                  deal?.specs?.inspiration ? (
                    <VerticalStack gap="2">
                      <Text variant="headingSm">Inspiration Examples</Text>
                      <VerticalStack gap="1">
                        <div dangerouslySetInnerHTML={{ __html: deal?.specs?.inspiration }} />
                      </VerticalStack>
                    </VerticalStack>
                  ) : null
                }
                {
                  deal?.assets?.length ? (
                    <VerticalStack gap="2">
                      <Divider />
                      <Text variant="headingSm">Assets</Text>
                      <HorizontalStack gap="5" align="start">
                        {
                          deal?.assets?.map((asset, index) => {
                            return (
                              <HorizontalStack key={index} gap="1" blockAlign="center" align="start">
                                <HorizontalStack>
                                  <Icon color="interactive" source={asset?.name?.includes('doc') || asset?.name?.includes('pdf') ? PagePlusMajor : ImagesMajor} />
                                </HorizontalStack>
                                <Link removeUnderline url={asset.url}>{asset.name}</Link>
                              </HorizontalStack>
                            )
                          })
                        }
                      </HorizontalStack>
                    </VerticalStack>
                  ) : null
                }
              </VerticalStack>
            </VerticalStack>
          </AlphaCard>
        ) : null
      }
      {
        (deal?.products?.selectedVariants?.length) ? (
          <AlphaCard>
            <VerticalStack gap="5">
              <HorizontalStack blockAlign="center" align="space-between">
                <HorizontalStack gap="3" align="start">
                  <HorizontalStack>
                    <Icon source={AddProductMajor} />
                  </HorizontalStack>
                  <VerticalStack gap="1">
                    <Text variant="headingMd">You Will Receive</Text>
                  </VerticalStack>
                </HorizontalStack>
                <VerticalStack inlineAlign="end">
                  <Text variant="bodyMd">Order Status</Text>
                  {
                    deal?.order?.status === 'fulfilled' ? (
                      <Badge status="info">Shipped</Badge>
                    ) : deal?.order?.id ? (
                      <Badge status="info">Order Created</Badge>
                    ) : (
                      <Badge>Pending</Badge>
                    )
                  }
                </VerticalStack>
              </HorizontalStack>
              <Divider />
              <HorizontalGrid gap="5" columns="3">
                {
                  deal.order?.shippedVariants?.map((variant, index) => (
                    <VerticalStack key={index} gap="1">
                      <Image width="100%" source={variant.image} />
                      <HorizontalStack>
                        <Text variant="headingSm">{variant.title}</Text>
                        <Text color="subdued">${variant.price}</Text>
                      </HorizontalStack>
                    </VerticalStack>
                  ))
                }
              </HorizontalGrid>
              {/*
                      <Divider />
                      <HorizontalStack gap="5">
                        {totalSelectedValue > 0 ? (
                          <VerticalStack inlineAlign="center" gap="1">
                            <Text variant="headingLg" color={Number(totalSelectedValue) <= Number(deal?.products?.maxProductValue) ? "success" : "critical"}>${totalSelectedValue}</Text>
                            <Text color="subdued">Total Value</Text>
                          </VerticalStack>
                        ) : null}
                        {totalSelectedValue > 0 ? (
                          <VerticalStack inlineAlign="center" gap="1">
                            <Text variant="headingLg" color={Number(totalSelectedQuantity) <= Number(deal?.products?.maxProductQuantity) ? "success" : "critical"} >{totalSelectedQuantity}</Text>
                            <Text color="subdued">Total Quantity</Text>
                          </VerticalStack>
                        ) : null}
                      </HorizontalStack>
                  */}
            </VerticalStack>
          </AlphaCard>
        ) : null
      }
    </VerticalStack>
  )
}
